import {formatearNumero} from "../../../Commons/Scripts/Utils/formatear";
import {getLinkDiario, getLinkDocumento} from "../Utils/get-link";
import React, {useState, useEffect} from 'react';
import { DataTable, Column, Skeleton } from 'primereact';
import {useForm} from "../../../Commons/Scripts/Hooks/useForm";
import {UrlReporte, useImprimir} from "../../../Commons/Scripts/Hooks/useImprimir";
import {SimpleForm} from "../../../Commons/Scripts/Componentes/Form";
import {DateField} from "../../../Commons/Scripts/Componentes/DateField";
import {SelectField} from "../../../Commons/Scripts/Componentes/SelectField";
import {CheckboxField} from "../../../Commons/Scripts/Componentes/CheckboxField";
import {Button2} from "../../../Commons/Scripts/Componentes/Button";

const origin = window.location.origin;

function FormularioMayorGeneral({
  onSubmit,
  valorInicial = {},
  periodosContables,
  periodosFiscales,
  expresadosEn,
  cuentas,
  fuentesDocumento,
  razones,
  onChange,
  filtros,
  limpiarFiltros,
  where,
  loading,
}) {
  const { useEffect } = React;
  const form = useForm(valorInicial);

  const [loadingPdf, handlePdf] = useImprimir(UrlReporte.MAYOR_GENERAL, "PDF");
  const [loadingExcel, handleExcel] = useImprimir(UrlReporte.MAYOR_GENERAL, "Excel");
  const [loadingCsv, handleCsv] = useImprimir(UrlReporte.MAYOR_GENERAL, "CSV");

  useEffect(() => {
    if (expresadosEn) {
      form.setValue("expresadoEn", expresadosEn[0]);
    }
  }, [expresadosEn]);

  useEffect(() => {
    const cuenta = cuentas.filter((c) => c.value === filtros?.IdentificadorCuenta);
    form.setValue("cuenta", cuenta);
    if (filtros?.FechaInicio && filtros?.FechaFin) {
      form.setValue("fechaInicio", filtros?.FechaInicio);
      form.setValue("fechaFin", filtros?.FechaFin);
    }
  }, [filtros]);

  const handleSubmit = () => {
    onSubmit(form.values);
  };

  return (
    <SimpleForm formulario={form} onChange={onChange}>
      <div className="row">
        <DateField name="fechaInicio" label="Fecha Inicio" mostrarIcono={true} />
      </div>
      <div className="row">
        <DateField name="fechaFin" label="Fecha Fin" mostrarIcono={true} />
      </div>
      <div className="row">
        <SelectField
          name="periodoFiscal"
          opciones={periodosFiscales}
          placeholder="Seleccione un período fiscal"
          label="Periodo Fiscal"
          opcionPorDefecto={true}
          width="250px"
        />
      </div>
      <div className="row">
        <SelectField
          name="periodoContable"
          opciones={periodosContables}
          placeholder="Seleccione un período contable"
          label="Periodo Contable"
          opcionPorDefecto={true}
          width="250px"
        />
      </div>
      <div className="row">
        <SelectField name="expresadoEn" opciones={expresadosEn} label="Expresado en" />
      </div>
      <div className="row">
        <SelectField isMulti name="cuenta" opciones={cuentas} label="Cuenta" width="500px" placeholder="Cuentas..." />
      </div>
      <div className="row">
        <SelectField name="tipoDocumento" opciones={fuentesDocumento} label="Tipo Documento" placeholder="Todos" />
      </div>

      <div className="row">
        <SelectField name="razon" opciones={razones} label="Razón" placeholder="Todos" opcionPorDefecto={true} />
      </div>
      <div
        style={{
          display: "flex",
          gap: "0 5px",
          margin: "10px 0 10px 150px",
        }}
      >
        <div className="row">
          <CheckboxField name="sinMovimiento" label="Sin Movimiento" />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: "0 5px",
          margin: "10px 0 10px 150px",
        }}
      >
        <Button2 texto="Buscar" icono="buscar" loading={loading} onClick={handleSubmit} />
        <Button2 texto="PDF" icono="imprimir" loading={loadingPdf} onClick={() => handlePdf({ ...where.where })} />
        <Button2 texto="Excel" icono="imprimir" loading={loadingExcel} onClick={() => handleExcel({ ...where.where })} />
        <Button2 texto="CSV" icono="imprimir" loading={loadingCsv} onClick={() => handleCsv({ ...where.where })} />
      </div>
    </SimpleForm>
  );
}

function TablaMayorGeneral({ data, loading, expresado, filtros, filtro }) {
  const [expandedRows, setExpandedRows] = useState([]);

  useEffect(() => {
    if (filtros?.IdentificadorCuenta) {
      const row = data?.filter((d) => d.IdentificadorCuenta.startsWith(filtros?.IdentificadorCuenta));

      if (filtros?.Fuente === "ESTADO_RESULTADO" && row && row.length > 0) {
        setExpandedRows([row[0]]);
      } else if (row && row.length > 0) {
        setExpandedRows([...row]);
      }
    }

    if (filtro === false) {
      setExpandedRows([]);
    }
  }, [data, filtros, filtro]);

  const headerTemplate = (data) => {
    return (
      <React.Fragment>
        <span
          onClick={() => {
            setExpandedRows((prevState) => {
              const exists = prevState?.some((p) => p.IdentificadorCuenta === data.IdentificadorCuenta);

              if (exists) {
                return prevState.filter((row) => row.IdentificadorCuenta !== data.IdentificadorCuenta);
              } else {
                return [...prevState, data];
              }
            });
          }}
        >
          <span>
            {data.CuentaNombre} - {data.IdentificadorCuenta}
          </span>
          <span style={{ display: "block", width: "100%", textAlign: "right" }}>
            <b>Saldo Inicial: </b>
            {formatearNumero(data.SaldoInicial)}
          </span>
        </span>
      </React.Fragment>
    );
  };

  if (loading) {
    return (
      <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
        <Column body={<Skeleton style={{ height: "40px" }} />} />
      </DataTable>
    );
  }

  return (
    <div>
      <DataTable
        id="grid"
        value={data}
        tableStyle={{ minWidth: "40rem" }}
        rowGroupMode="subheader"
        groupRowsBy="IdentificadorCuenta"
        sortMode="single"
        sortField="CuentaNombre"
        sortOrder={0}
        expandableRowGroups
        expandedRows={expandedRows}
        onRowToggle={(e) => {
          setExpandedRows(e.data);
        }}
        rowGroupHeaderTemplate={headerTemplate}
        emptyMessage="No hay registros"
      >
        <Column
          body={(item) => {
            const link = getLinkDocumento(origin, item);

            return (
              <React.Fragment>
                {link === "" ? (
                  <span>{item.Tipo}</span>
                ) : (
                  <a className="link" href={link} target="_blank">
                    {item.Tipo}
                  </a>
                )}
              </React.Fragment>
            );
          }}
          header="Tipo"
          style={{ verticalAlign: "middle" }}
        />
        <Column
          body={(item) => {
            const link = getLinkDocumento(origin, item);

            return (
              <React.Fragment>
                {link === "" ? (
                  <span>{item.Referencia}</span>
                ) : (
                  <a className="link" href={link} target="_blank">
                    {item.Referencia}
                  </a>
                )}
              </React.Fragment>
            );
          }}
          header="Ref."
          style={{ verticalAlign: "middle" }}
        />
        <Column field="Descripcion" header="Descripcion" style={{ maxWidth: "250px" }} />
        <Column
          headerClassName="align-right"
          style={{ textAlign: "right" }}
          header="Fecha"
          body={(item) => {
            return <span>{item.FechaTransaccion}</span>;
          }}
        />
        <Column
          header="Diario Id"
          headerClassName="align-right"
          style={{ textAlign: "right" }}
          body={(item) => {
            const link = getLinkDiario(origin, item);

            return (
              <a className="link" href={link} target="_blank">
                {item.Numero}
              </a>
            );
          }}
        />
        <Column
          header="Débito"
          headerClassName="align-right"
          style={{ textAlign: "right" }}
          body={(item) => {
            const link = getLinkDiario(origin, item);

            return (
              <a className="link" href={link} target="_blank">
                {formatearNumero(item.Debito)}
              </a>
            );
          }}
        />
        <Column
          header="Crédito"
          headerClassName="align-right"
          style={{ textAlign: "right" }}
          body={(item) => {
            const link = getLinkDiario(origin, item);

            return (
              <a className="link" href={link} target="_blank">
                {formatearNumero(item.Credito)}
              </a>
            );
          }}
        />
        <Column
          header="Balance"
          headerClassName="align-right"
          style={{ textAlign: "right" }}
          body={(item) => {
            const link = getLinkDiario(origin, item);

            return (
              <a className="link" href={link} target="_blank">
                {formatearNumero(item.Balance)}
              </a>
            );
          }}
        />
      </DataTable>
    </div>
  );
}

export function MayorGeneral({
  handleSubmitMG,
  valorInicial,
  periodosContablesMG,
  periodosFiscales,
  expresadosEn,
  cuentas,
  fuentesDocumento,
  razones,
  handleOnChangeFormularioMG,
  filtros,
  filtro,
  data,
  loading,
  where,
  isEstadoResultado,
  isBalanceComprobacion,
  isMayorGeneral,
  setTab,
}) {
  return (
    <div>
      <FormularioMayorGeneral
        onSubmit={handleSubmitMG}
        valorInicial={valorInicial}
        periodosContables={periodosContablesMG}
        periodosFiscales={periodosFiscales}
        expresadosEn={expresadosEn}
        cuentas={cuentas}
        fuentesDocumento={fuentesDocumento}
        razones={razones}
        onChange={handleOnChangeFormularioMG}
        filtros={filtros}
        where={where}
        loading={loading}
      />

      <br />
      <br />
      <div className="inMenu">
        <div className="inMenuItem">
          {isEstadoResultado != undefined && (
            <span
              className={isEstadoResultado ? "subTitle" : "linkSubtitulo"}
              onClick={() => setTab("ESTADO_RESULTADO")}
            >
              Estado Resultado
            </span>
          )}
          {isBalanceComprobacion != undefined && (
            <span
              className={isBalanceComprobacion ? "subTitle" : "linkSubtitulo"}
              onClick={() => setTab("BALANCE_COMPROBACION")}
            >
              Balanza Comprobación
            </span>
          )}
        </div>
        <div className="inMenuItem">|</div>
        <div className="inMenuItem">
          <span className={isMayorGeneral ? "subTitle" : "linkSubtitulo"} onClick={() => setTab("MAYOR_GENERAL")}>
            Mayor General
          </span>
        </div>
        <div className="fix"></div>
      </div>
      <br />

      <TablaMayorGeneral data={data} loading={loading} filtros={filtros} filtro={filtro} />
    </div>
  );
}
